import { Box, BoxProps } from "@mantine/core";
import { ReactNode } from "react";
import cx from "clsx";
import styles from "@scss/custom-components/nav.module.scss";

interface CustomNavWrapperProps extends BoxProps {
  children?: ReactNode;
}

export const CustomNavWrapper = ({
  children,
  className,
  ...props
}: CustomNavWrapperProps) => {
  const items = Array.isArray(children) ? children : [children];

  return (
    <Box className={cx(styles.navWrapper, className)} {...props}>
      {items.map((child: any, index) => {
        const isActive = child?.props?.active;

        return (
          <div
            key={index}
            className={styles.navItem}
            data-active={isActive || undefined}
          >
            {child}
          </div>
        );
      })}
    </Box>
  );
};
